"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.initialState = void 0;
var seamless_immutable_1 = __importDefault(require("seamless-immutable"));
var chatCleanReducer_1 = __importDefault(require("./reducers/chatCleanReducer"));
var chatRoomMessageQueueReducer_1 = __importDefault(require("./reducers/chatRoomMessageQueueReducer"));
var chatRoomMessagesReducer_1 = __importDefault(require("./reducers/chatRoomMessagesReducer"));
var chatRoomReducer_1 = __importDefault(require("./reducers/chatRoomReducer"));
var chatUsersReducer_1 = __importDefault(require("./reducers/chatUsersReducer"));
exports.initialState = {
    isSocketOpen: false,
    isSocketConnected: false,
    isSocketWarningEnabled: false,
    currentRoom: null,
    me: null,
    rooms: {},
    chatUpdateDate: null,
    users: {},
    ignoreUsers: []
};
function reducer(state, action) {
    if (state === void 0) { state = seamless_immutable_1["default"](exports.initialState); }
    state = chatRoomReducer_1["default"](state, action);
    state = chatRoomMessagesReducer_1["default"](state, action);
    state = chatRoomMessageQueueReducer_1["default"](state, action);
    state = chatUsersReducer_1["default"](state, action);
    state = chatCleanReducer_1["default"](state, action);
    return state;
}
exports["default"] = reducer;
